module.exports = __webpack_public_path__ + "resources/img/main10.16d50f512cf7f6838d8eddb2e6bb18c0.png";